var _style, _g, _path, _rect, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIsologoCercalite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 652.6 157.9",
    style: {
      enableBackground: "new 0 0 652.6 157.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#42AE58;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#42AE58;}\n")), /*#__PURE__*/React.createElement("g", null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 51.8,
    transform: "matrix(-1 -1.090262e-10 1.090262e-10 -1 158.0055 115.2946)",
    className: "st0",
    width: 36.7,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 73.4,
    transform: "matrix(-1 -1.089272e-10 1.089272e-10 -1 158.0055 158.4739)",
    className: "st0",
    width: 36.7,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 60.6,
    y: 95.4,
    transform: "matrix(-1 -1.090760e-10 1.090760e-10 -1 158.0055 202.4072)",
    className: "st0",
    width: 36.7,
    height: 11.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18.4,
    y: 73.7,
    transform: "matrix(-1.213625e-11 1 -1 -1.213625e-11 124.8178 33.4351)",
    className: "st0",
    width: 54.6,
    height: 10.8
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0394,
    y1: 11.38,
    x2: 79.0394,
    y2: 163.3191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#549BD2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#4982B3"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M141.9,6.8H16.2c-5.3,0-9.6,4.3-9.6,9.6v126.4c0,5.3,4.3,9.6,9.6,9.6h125.7c5.3,0,9.6-4.3,9.6-9.6V16.4 C151.5,11.1,147.2,6.8,141.9,6.8z M79,136.9c-31.6,0-57.2-25.6-57.2-57.2S47.4,22.4,79,22.4c31.6,0,57.2,25.6,57.2,57.2 S110.7,136.9,79,136.9z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 86,
    y: 73.7,
    transform: "matrix(-1.170282e-11 1 -1 -1.170282e-11 192.3746 -34.1976)",
    className: "st0",
    width: 54.6,
    height: 10.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "R_00000075144749633164697860000012601132847354998144_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M633.3,53h1.7c1.1,0,1.8,0,2.1-0.1c0.3-0.1,0.5-0.3,0.6-0.5c0.2-0.2,0.2-0.5,0.2-0.9c0-0.4-0.1-0.7-0.3-0.9 c-0.2-0.2-0.5-0.4-0.9-0.4c-0.2,0-0.7,0-1.7,0h-1.8V53z M631,59.6V48.2h4.9c1.2,0,2.1,0.1,2.7,0.3c0.6,0.2,1,0.6,1.3,1.1 c0.3,0.5,0.5,1.1,0.5,1.8c0,0.9-0.3,1.6-0.8,2.1c-0.5,0.6-1.3,0.9-2.3,1c0.5,0.3,0.9,0.6,1.2,1c0.3,0.3,0.8,1,1.3,1.8l1.4,2.2 h-2.8l-1.7-2.5c-0.6-0.9-1-1.4-1.2-1.7c-0.2-0.2-0.5-0.4-0.7-0.5c-0.2-0.1-0.6-0.1-1.2-0.1h-0.5v4.7H631z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M635.5,43.9c5.5,0,10,4.5,10,10c0,5.5-4.5,10-10,10c-5.5,0-10-4.5-10-10C625.5,48.4,630,43.9,635.5,43.9  M635.5,45.2c4.8,0,8.8,3.9,8.8,8.7c0,4.8-3.9,8.7-8.8,8.7c-4.8,0-8.8-3.9-8.8-8.7C626.8,49.1,630.7,45.2,635.5,45.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M310.9,88h-35.4c0,1-0.1,1.9-0.1,2.6c0,4,1,7.1,3.1,9.2c2.1,2.1,4.6,3.1,7.5,3.1c5.4,0,8.6-3,9.7-8.9 l14.7,1.1c-4.1,13.1-12.4,19.7-25,19.7c-5.5,0-10.1-1.1-13.9-3.4c-3.8-2.3-7-5.6-9.5-9.9c-2.5-4.3-3.7-9.5-3.7-15.6 c0-9,2.5-16.3,7.5-21.8c5-5.5,11.4-8.3,19.2-8.3c7.1,0,13.1,2.6,18.2,7.7C308.4,68.5,310.9,76.7,310.9,88z M275.5,78.3H295 c-0.5-7.8-3.6-11.7-9.3-11.7C279.6,66.6,276.2,70.5,275.5,78.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.8,113.6h-15.7V56.8H336v10.6c2.3-7.9,6.2-11.8,11.9-11.8c0.8,0,1.8,0.1,2.9,0.2v16.5 c-3.3,0-5.9,0.5-7.7,1.6c-1.8,1-3.3,2.9-4.5,5.6c-1.2,2.7-1.7,6.4-1.7,11V113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.1,92.3c-0.6,6.7-3.2,12.1-7.7,16.3c-4.5,4.1-10.3,6.2-17.5,6.2c-7.8,0-14.1-2.6-19-7.9 c-4.9-5.3-7.3-12.4-7.3-21.3c0-8.9,2.5-16.1,7.5-21.6c5-5.5,11.6-8.3,20-8.3c6.7,0,12.3,2.1,16.7,6.2c4.4,4.2,6.8,9.4,7.3,15.6 L393,78.4c-0.5-6.8-3.4-10.2-8.6-10.2c-6.4,0-9.6,5.4-9.6,16.3c0,7.2,0.9,11.8,2.7,13.8c1.8,1.9,4,2.9,6.6,2.9c5,0,8-3.3,9-9.8 L408.1,92.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M464.7,113.6H449c-0.5-2.2-0.8-5.2-0.8-8.9c-2.8,4-5.5,6.7-8.2,8.1c-2.7,1.3-5.8,2-9.3,2 c-5.1,0-9.3-1.4-12.5-4.3c-3.2-2.9-4.8-6.8-4.8-11.6c0-3.6,0.9-6.8,2.8-9.8c1.8-3,4.8-5.3,8.9-7c4.1-1.7,11.5-3,22.4-3.8v-3.3 c0-5.5-2.7-8.3-8-8.3c-5.7,0-8.8,2.8-9.5,8.3l-15-1.5c1-6.4,3.9-11,8.9-13.7c4.9-2.7,10.5-4,16.8-4c3.7,0,7.3,0.4,10.6,1.3 c3.3,0.9,5.9,2.2,7.7,4c1.8,1.8,3.1,3.7,3.8,5.7c0.7,2,1,5.5,1,10.5v25.7C463.7,107.9,464,111.4,464.7,113.6z M447.5,86.4 c-11.3,1.2-17,4.7-17,10.6c0,2,0.6,3.7,1.8,5.1c1.2,1.4,2.9,2.2,5.1,2.2c2.9,0,5.2-1.2,7.2-3.7c1.9-2.5,2.9-5.5,2.9-9.1V86.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M487.5,113.6h-8.5V36.9h8.5V113.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M513.4,36.9v9.8h-9.2v-9.8H513.4z M513.1,56.8v56.7h-8.5V56.8H513.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555,107.5v7c-3,0.4-5.6,0.6-7.8,0.6c-10.6,0-15.9-5.7-15.9-17.2V63.7h-9.7v-6.9h9.7l0.4-14.3l7.9-0.8v15 h12.3v6.9h-12.3v35.6c0,5.8,2.9,8.8,8.8,8.8C550.3,108.2,552.6,108,555,107.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M598.7,96.6l7.9,1.7c-1.5,4.8-4.3,8.9-8.5,12c-4.2,3.2-9.2,4.8-14.8,4.8c-7.5,0-13.6-2.7-18.2-8.2 c-4.6-5.5-7-12.6-7-21.4c0-9,2.4-16.3,7.2-21.9c4.8-5.6,10.9-8.3,18.2-8.3c7.2,0,13,2.6,17.3,7.7c4.4,5.1,6.6,12.8,6.7,23h-39.9 c0,8.6,1.7,14.4,5.2,17.4s7.2,4.5,11,4.5C591,107.8,595.9,104.1,598.7,96.6z M598.3,79.4c-0.1-3.2-0.6-6-1.5-8.5 c-0.9-2.5-2.5-4.6-4.8-6.3S587,62,583.8,62c-4.2,0-7.8,1.6-10.8,4.7s-4.6,7.4-5,12.7H598.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M246.1,66.4l-5.2,0.3c-3.2,0.2-6-2-6.6-5.1c-1.4-7.2-5.3-10.8-11.7-10.8c-9.1,0-13.6,8.3-13.6,25 c0,9.6,1.2,16.1,3.7,19.6c2.5,3.4,5.9,5.1,10.4,5.1c5.9,0,10-3.3,12.1-9.9c0.9-2.7,3.5-4.4,6.3-4.3l4.4,0.3c4,0.3,6.8,4.2,5.6,8 c-1.7,5.5-4.5,10-8.4,13.3c-5.5,4.8-12.3,7.2-20.3,7.2c-9.8,0-17.8-3.5-24-10.5c-6.1-7-9.2-16.7-9.2-29c0-11.6,3-21,8.9-28.4 c5.9-7.4,14.1-11.1,24.4-11.1c15.5,0,25.1,7.4,28.8,22.3C252.7,62.3,250,66.1,246.1,66.4z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsologoCercalite);
export default __webpack_public_path__ + "static/media/isologo-cercalite.b2ef3582a1cd7c8d8cffaaa7d39f7f00.svg";
export { ForwardRef as ReactComponent };